var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.wrapper,
    on: {
      "click": _vm.handleOpen,
      "mouseleave": _vm.handleBlur,
      "mouseenter": _vm.handleFocus
    }
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "enter-active-class": _vm.theme.fadeEnterActive,
      "enter-class": _vm.theme.fadeEnter,
      "enter-to-class": _vm.theme.fadeEnterTo,
      "leave-active-class": _vm.theme.fadeLeaveActive,
      "leave-class": _vm.theme.fadeLeave,
      "leave-to-class": _vm.theme.fadeLeaveTo
    }
  }, [(_vm.isOpen) ? _c('div', {
    class: _vm.menuClasses
  }, [_c('transition-group', {
    attrs: {
      "appear": "",
      "name": "fade",
      "enter-active-class": _vm.theme.fadeEnterActive,
      "enter-class": _vm.theme.fadeEnter,
      "enter-to-class": _vm.theme.fadeEnterTo,
      "leave-active-class": _vm.theme.fadeLeaveActive,
      "leave-class": _vm.theme.fadeLeave,
      "leave-to-class": _vm.theme.fadeLeaveTo
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: index,
      class: _vm.theme.menuItem,
      on: {
        "click": function($event) {
          _vm.$emit('click', item)
        }
      }
    }, [_c('v-text', {
      attrs: {
        "type": "subheadling"
      }
    }, [_vm._v(_vm._s(item))])], 1)
  }))], 1) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2a49ac6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Menu/Menu.vue
// module id = 579
// module chunks = 0